import script from "./QuizMe.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizMe.vue?vue&type=script&setup=true&lang=js"

import "./QuizMe.vue?vue&type=style&index=0&id=75cd3e3c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cd3e3c"]])

export default __exports__